export default __webpack_public_path__ + "static/media/hotei18.b9dc8577.webp";